/* eslint-disable react/no-unstable-nested-components */
import { Toggle } from "components/ui/Toggle";
import { SimpleTextTooltip } from "components/ui/Tooltip";
import classNames from "components/ui/classNames";
import { TagIcon } from "lucide-react";
import { type HTMLAttributes } from "react";
import { useIntl } from "react-intl";

interface ToggleDataLabelsButtonProps extends HTMLAttributes<HTMLButtonElement> {
  pressed?: boolean;
  onPressedChange: (pressed: boolean) => void;
}

export default function ToggleDataLabelsButton({
  pressed,
  onPressedChange,
  className,
  ...props
}: ToggleDataLabelsButtonProps) {
  const intl = useIntl();

  return (
    <SimpleTextTooltip
      content={
        pressed
          ? intl.formatMessage({ defaultMessage: "Ocultar valores no gráfico", id: "QgF0G7" })
          : intl.formatMessage({ defaultMessage: "Exibir valores no gráfico", id: "jSgkJI" })
      }
    >
      <Toggle
        {...props}
        disabled={false}
        type="button"
        onPressedChange={onPressedChange}
        className={classNames(
          "rounded-xl border border-slate-200 bg-slate-50/60 p-1 text-slate-600",
          "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
          "focus-visible:outline-none",
          "focus-visible:ring-1 focus-visible:ring-offset-1",
          "focus-visible:ring-gray-100 focus-visible:ring-offset-gray-300",
          "focus-visible:border-transparent focus-visible:bg-gray-50 focus-visible:text-gray-600",
          "dark:focus-visible:ring-slate-950 dark:focus-visible:ring-offset-transparent",
          {
            "dark:bg-violet-600/20 dark:text-violet-200": pressed,
            "bg-violet-50 text-violet-600": pressed,
          },
          className,
        )}
      >
        <TagIcon
          absoluteStrokeWidth={true}
          strokeWidth={2}
          className={classNames({
            "fill-violet-200": pressed,
          })}
        />
      </Toggle>
    </SimpleTextTooltip>
  );
}
